import api from '@/utils/api'

export default {
    setWxConfig({ commit }, wxConfig) {
        return new Promise((resolve, reject) => {
            commit('SET_WX_CONFIG', wxConfig)

            resolve()
        })
    },
    setReadyKeyword({commit},readyKeyword){
        return new Promise((resolve,reject)=>{
            commit('SET_Ready_Keyword', readyKeyword)

            resolve()
        })
    },
    setSearchParams({commit},searchParams){
        return new Promise((resolve,reject)=>{
            commit('SET_SEARCH_PARAMS', searchParams)

            resolve()
        })
    }


}



// WEBPACK FOOTER //
// ./src/vuex/actions.js